<button
  (click)="onClick()" class="w-36 sm:w-44 hover:cursor-pointer hover:border rounded-lg border-transparent ">
  <div class="relative">
    <ln-ln-image-frame src = "{{seller.urlImgLogo}}" alt="logo1" class="w-36 sm:w-44 h-40 rounded-lg"></ln-ln-image-frame>
    <!--      <div class="absolute top-1 right-1">-->

    <!--        @if(product.isFavorito) {-->
    <!--          <ln-ln-fav-beige-svg-icon class="w-8 h-8 hover:cursor-pointer hover:scale-110 transition duration-500"></ln-ln-fav-beige-svg-icon>-->
    <!--        } @else {-->
    <!--           <ln-ln-fav-bg-beige-svg-icon class="w-8 h-8 hover:cursor-pointer hover:scale-110 transition duration-500"></ln-ln-fav-bg-beige-svg-icon>-->
    <!--        }-->
    <!--      </div>-->
  </div>

  <div class="line-clamp-2 w-36 overflow-hidden text-ellipsis break-words mb-3 mt-2 text-start justify-start text-cafe text-base font-normal font-['Roboto']">{{seller.nombre}}</div>

  <!--    <div class=" grid grid-cols-5 gap-0 mt-1 mr-20">-->
  <!--      @for(estrallas of [].constructor(5); track $index) {-->
  <!--        <ln-ln-start-svg-icon class="w-20 h-20"></ln-ln-start-svg-icon>-->
  <!--      }-->
  <!--    </div>-->
</button>



